module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "img-view",
    on: {
      "click": _vm.bigImg
    }
  }, [_c('div', {
    staticClass: "img-layer"
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('div', {
    staticClass: "infos"
  }, [_c('span', {
    staticStyle: {
      "color": "white",
      "margin-right": "10px"
    }
  }, [_vm._v("学校：" + _vm._s(_vm.school))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "white",
      "margin-right": "10px"
    }
  }, [_vm._v("姓名：" + _vm._s(_vm.name))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "white",
      "margin-right": "10px"
    }
  }, [_vm._v("学号：" + _vm._s(_vm.campusId))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.imgSrc,
      "id": "myImg"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.myclick()
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1c4cde27!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/userM/BigImg.vue
// module id = 960
// module chunks = 0